module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"none":"None","Mr.":"Mr.","Ms.":"Ms.","salutation":"Salutation"},"de":{"none":"Keine","Mr.":"Herr","Ms.":"Frau","salutation":"Anrede"}}')
  delete Component.options._Ctor
}
